// Lets any page open the global Compose window addressed to someone (the contact
// page's "Email" button). TopNav owns the dialog and listens for this event.

export const COMPOSE_EVENT = 'pa:open-compose';

/** Open Compose with the To field filled in. */
export function openComposeTo(to: string): void {
  window.dispatchEvent(new CustomEvent<{ to: string }>(COMPOSE_EVENT, { detail: { to } }));
}
